import { render, staticRenderFns } from "./backindex.vue?vue&type=template&id=a0276338&scoped=true&"
import script from "./backindex.vue?vue&type=script&lang=js&"
export * from "./backindex.vue?vue&type=script&lang=js&"
import style0 from "./backindex.vue?vue&type=style&index=0&id=a0276338&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0276338",
  null
  
)

export default component.exports